import React, {useEffect, useState} from "react";
import {ControlLabel, FormGroup} from "react-bootstrap";

const CPSettingRadio = ({
    name,
    eventValue,
    defaultValue,
    label,
    options,
    onChange,
    hint = '',
}) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(eventValue || defaultValue);
    }, [eventValue]);

    const handleChangeValue = (value) => {
        setValue(value);
        onChange({[name]: value});
    };

    return (
        <FormGroup>
            <FormGroup style={{display: 'flex', flexDirection: 'column'}}>
                <ControlLabel style={{fontWeight: 'normal'}}>
                    {label}:
                </ControlLabel>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px 16px',
                    }}
                >
                    {
                        !!options.length && options.map((option) => (
                            <label
                                key={option.value}
                                style={{fontWeight: 'normal'}}
                            >
                                <input
                                    type="radio"
                                    value={option.value}
                                    name={`${name}-${option.value}`}
                                    checked={option.value === value}
                                    onChange={({target}) => handleChangeValue(target.value)}
                                />
                                &nbsp; {option.label}
                            </label>
                        ))
                    }
                </div>
            </FormGroup>
            {
                !!hint &&
                <p>
                    <i>
                        ({hint})
                    </i>
                </p>
            }
        </FormGroup>
    );
};

export default CPSettingRadio;
